import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { DrawerClose, DrawerFooter } from '@/components/ui/drawer';
import { useToken } from '@/context/useToken';
import SpinnerButton from '@/components/common/SpinnerButton';
import { useCartCookie } from '@/helpers/useCartCookie';

import { usePostLogin } from '@/data/user';
import { useGetCartSelf } from '@/data/cart';

const LoginForm = ({ onSuccess }) => {
  const { setToken } = useToken();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const postLogin = usePostLogin();
  const { getCartId, setCartId } = useCartCookie();
  const getCartSelf = useGetCartSelf();

  const handleSubmit = async () => {
    if (!email || !password) {
      setError('email and password required.');
      return;
    }
    const payload = {
      email,
      password
    };

    setSubmitting(true);
    try {
      const token = await postLogin(payload);
      setError('');
      setSubmitting(false);
      setToken(token);

      // If theres no cartId cookie, fetch the user's carts and set the first one as the cartId
      if (!getCartId()) {
        const userCarts = await getCartSelf();
        if (userCarts.length > 0) {
          const cartId = userCarts[0].id;
          setCartId(cartId);
        }
      }
      await onSuccess();
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };
  return (
    <div className="text-left">
      <form>
        <div className="mb-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            placeholder="enter email..."
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-2">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            placeholder="enter password..."
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
      </form>
      {error && (
        <Alert variant="destructive">
          <AlertCircle size={18} />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <DrawerFooter className="px-0 space-y-3">
        <SpinnerButton onClick={handleSubmit} loading={submitting}>
          Login
        </SpinnerButton>
        <DrawerClose asChild>
          <div>
            <div className="flex gap-4 mb-8">
              <Link to="/signup" className="w-1/2">
                <Button variant="outline" className="w-full">
                  Sign Up
                </Button>
              </Link>
              <Button variant="outline" className="w-1/2">
                Cancel
              </Button>
            </div>
            <div className="flex justify-center">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>
          </div>
        </DrawerClose>
      </DrawerFooter>
    </div>
  );
};

export default LoginForm;
